export const consentConstant = {
  CONSENT_ACCEPTED: 'accepted',
  CONSENT_REJECTED: 'rejected',
  CONSENT_NOT_ACCEPTED: 'not accepted',
  TERM_TYPE: {
    SOLUTION_TERMS: 'Solution Terms',
    API_TERMS: 'API Terms'
  },
  CONNECTION_STATUS: {
    INACTIVE: 'inactive',
    ACTIVE: 'active',
    PENDING: 'pending'
  },
  CONSENT_TYPE: {
    SOLUTION_TNC: 'solution_tnc',
    API_DATA: 'api_data',
    PLUGIN_TERMS: 'plugin_terms'
  },
  NOT_PROVIDED: 'Not Provided',
  SUBSCRIPTION_STATUS_COMPLETED: 'completed',
  CONSENTED_SOURCE: 'dealerportal',
  DEFAULT_SUBS_STATUS: '',
  SUBSCRIPTION_STATUS_FOR_NEW_CONNECTION: 'new',
  SUBSCRIBED_SOURCE: 'dealerportal',
  MONETISATION_SERVICE_AGREEMENT :'Monetisation Service Agreement' 
};
